import { PageType } from '../../types/graphql';
export type ResolvedPageParams = {
  resolvedType: PageType | undefined;
  resolvedSlug: string;
};
export const resolvePageQueryParams = (
  pageType: PageType,
  slug?: string | null
): ResolvedPageParams => {
  return {
    resolvedType: [
      PageType.OnePage,
      PageType.Fundraising,
      PageType.Charity,
    ].includes(pageType)
      ? undefined
      : pageType,
    resolvedSlug:
      slug &&
      pageType === PageType.Fundraising &&
      !slug.startsWith('fundraising/')
        ? (slug = 'fundraising/' + slug)
        : slug ?? '',
  };
};
